import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { motion } from "framer-motion";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function BarGraph({
  data,
  labels,
  yTitle,
  title,
  isPreview,
}: {
  data: any;
  labels: string[];
  yTitle: string;
  title?: string;
  isPreview?: boolean;
}) {
  const [graphData, setGraphData] = useState<any>();

  useEffect(() => {
    if (data && data.length > 0) {
      setGraphData({ labels, datasets: data });
    }
  }, [data]);

  if (!graphData) return null;

  return (
    <motion.div
      className="h-full w-full"
      key="carousel-container"
      initial={{ y: 300, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -300, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <Bar
        options={{
          scales: {
            x: {
              grid: {
                color: "rgba(255,255,255,0.03)",
              },
              ticks: {
                color: "rgba(255,255,255,1)",
              },
            },
            y: {
              grid: {
                color: "rgba(255,255,255,0.07)",
              },
              ticks: {
                color: "rgba(255,255,255,1)",
              },
              title: {
                display: true,
                text: yTitle,
                color: "rgba(255,255,255,1)",
                font: {
                  size: 16,
                },
              },
            },
          },
          maintainAspectRatio: false,
          responsive: true,
          plugins: {
            legend: {
              position: "bottom",
              labels: {
                boxHeight: 8,
                boxWidth: 25,
                color: "rgba(255,255,255,0.8)",
                font: {
                  size: 14,
                },
              },
            },
            title: {
              display: true,
              text: title,
              color: isPreview ? "rgba(255,255,255,0.5)" : "rgba(255,255,255,1)",
              font: {
                weight: isPreview ? "medium" : "bold",
              },
            },
          },
        }}
        data={graphData}
        style={{ backgroundColor: "" }}
      />
    </motion.div>
  );
}
